import { Priority } from "./Priority";
import HighestPriority from "../assets/images/icons/highest.svg";
import HighPriority from "../assets/images/icons/priority.svg";
import MediumPriority from "../assets/images/icons/equal_img (2).svg";
import LowPriority from "../assets/images/icons/down_arrow.svg";
import { TechnologySector } from "./Status";


export const TaskPriorityIcon = (priority) => {
    switch (priority) {
      case Priority.HIGHEST:
        return HighestPriority;
      case Priority.HIGH:
        return HighPriority;
      case Priority.MEDIUM:
        return MediumPriority;
      case Priority.LOW:
        return LowPriority;
      default:
        return MediumPriority;
    }
};

export const SectorColor = (sector) => {
  switch (sector) {
    case TechnologySector.ENERGY_INDUSTRY_SECTOR:
      return '#FF5122';
    case TechnologySector.FUTURE_ECONOMY_SECTOR:
      return '#7100E5';
    case TechnologySector.HELATH_SECTOR:
      return '#0053E7';
    case TechnologySector.SUSTAINABILIY_ENVIRONMENT_SECTOR:
      return '#009457';
    default: return;
  }
}

export const FundStage = (stage) => {
  switch (stage) {
    case 'stage1':
      return 'Idea';
    case 'stage2':
      return 'Pre-seed';
    case 'stage3':
      return 'Seed';
    case 'stage4':
      return 'Series A+';
    case 'Idea':
      return 'stage1'
     case 'Pre-seed':
      return 'stage2'
    case 'Seed':
      return 'stage3'
     case 'Series A+':
      return 'stage4'
    default: return;
  }
}

export const fetchSector = (sector) => {
  switch (sector) {
    case TechnologySector.ENERGY_INDUSTRY_SECTOR?.replaceAll(/\s|and/gi, ""):
      return TechnologySector.ENERGY_INDUSTRY_SECTOR;
    case TechnologySector.FUTURE_ECONOMY_SECTOR?.replaceAll(/\s|and/gi, ""):
      return TechnologySector.FUTURE_ECONOMY_SECTOR;
    case TechnologySector.HELATH_SECTOR?.replaceAll(/\s|and/gi, ""):
      return TechnologySector.HELATH_SECTOR;
    case TechnologySector.SUSTAINABILIY_ENVIRONMENT_SECTOR?.replaceAll(/\s|and/gi, ""):
      return TechnologySector.SUSTAINABILIY_ENVIRONMENT_SECTOR;
    default: return;
  }
}